var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6404 22.1198C17.7604 22.3798 16.7204 22.4998 15.5004 22.4998H9.50035C8.28035 22.4998 7.24035 22.3798 6.36035 22.1198C6.58035 19.5198 9.25035 17.4697 12.5004 17.4697C15.7504 17.4697 18.4204 19.5198 18.6404 22.1198Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5H9.5C4.5 2.5 2.5 4.5 2.5 9.5V15.5C2.5 19.28 3.64 21.35 6.36 22.12C6.58 19.52 9.25 17.47 12.5 17.47C15.75 17.47 18.42 19.52 18.64 22.12C21.36 21.35 22.5 19.28 22.5 15.5V9.5C22.5 4.5 20.5 2.5 15.5 2.5ZM12.5 14.67C10.52 14.67 8.92 13.06 8.92 11.08C8.92 9.10002 10.52 7.5 12.5 7.5C14.48 7.5 16.08 9.10002 16.08 11.08C16.08 13.06 14.48 14.67 12.5 14.67Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0799 11.08C16.0799 13.06 14.4799 14.67 12.4999 14.67C10.5199 14.67 8.91992 13.06 8.91992 11.08C8.91992 9.10002 10.5199 7.5 12.4999 7.5C14.4799 7.5 16.0799 9.10002 16.0799 11.08Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.ecc142d26d3c105b1e07f1d54f2e032d.svg";
export { ForwardRef as ReactComponent };